'use strict';

import store from './StoreHelper.js';
import { setAuthData } from '../actions/setAuthData.js';

const GATEWAY = process.env.API_BASE_URL;

const API_URLS = {
  root: `<GATEWAY>`,
  api: `<GATEWAY>/api`
};

const EXPOSED_ENDPOINTS = [`/token`, `/token/refresh`];

let refreshedToken = false;

const $ = (options, lastAttempt, retryCount) => {
  retryCount = retryCount || 0;
  let request = new XMLHttpRequest(),
    params = options.params || { },
    body = options.body || { },
    success = options.success || (() => {}),
    error = options.error || (() => {}),
    paramString,
    API_URL = API_URLS[options.api || `api`].replace(/\<GATEWAY\>/g, GATEWAY).replace(/\<CLIENT_ID\>/g, () => {
      return store.getState().login.client_id;
    });

  if (!refreshedToken && !options.hasOwnProperty(`token`) && !EXPOSED_ENDPOINTS.includes(options.url)) return setTimeout(() => $(options, lastAttempt), 500);

  if (Object.keys(params).length > 0) {
    paramString = `?${ Object.keys(params)
      .filter((opt) => params[opt] !== undefined && params[opt] !== null)
      .map((opt) => {
        return `${ opt }=${ params[opt] }`;
      }).join(`&`) }`;
  } else {
    paramString = ``;
  }

  request.onreadystatechange = () => {
    if (request.readyState !== 4) {
      return;
    }

    if (request.status === 401) {
      if (lastAttempt) {
        store.dispatch(setAuthData());
        return;
      }

      return setTimeout(() => {
        $(options, true);
      }, 500);
    }

    if (request.status === 403) {
      if (!refreshedToken) {
        $(options, lastAttempt);
        return;
      } else {
        // sendRefreshToken((token) => {
        //   $({ ...options, token }, lastAttempt, gateway_auth_request);
        // });
        return;
      }
    }

    if (request.status.toString()[0] === `2` && !request._hasError) {
      let responseText = request.responseText.length > 0 ? JSON.parse(request.responseText) : { };

      if (options.authRequest) {
        refreshedToken = true;

        store.dispatch(setAuthData(responseText.access, responseText.refresh || options.body.refresh));
      }

      success(responseText);
    } else {
      const isNetworkError = request.status === 0;
      const isServerError = request.status >= 500;
      const isGet = !options.type || options.type === `GET`;
      const shouldRetry = isGet && (isNetworkError || isServerError) && retryCount < 3;

      if (shouldRetry) {
        const delay = Math.pow(2, retryCount) * 1000;
        return setTimeout(() => $(options, lastAttempt, retryCount + 1), delay);
      }

      error();
    }
  };

  request.open(
    options.type || `GET`,
    `${ API_URL }${ options.url || `` }${ paramString }`
  );

  if (!options.hasOwnProperty(`formData`)) {
    request.setRequestHeader(`Content-Type`, options.contentType || `application/json`);
  } 

  let auth = store.getState().auth;

  if (options.token) {
    request.setRequestHeader(`Authorization`, `Bearer ${ options.token }`);
  } else if (auth.isAuthed && options.api !== `timezone`) {
    request.setRequestHeader(`Authorization`, `Bearer ${ auth.token }`);
  } 

  if (options.hasOwnProperty(`formData`)) {
    request.send(options.formData);
  } else {
    request.send(JSON.stringify(body) || undefined);
  }
};

export { $ };



// WEBPACK FOOTER //
// ./src/helpers/ApiHelper.js